import EmailImportService from '../../services/emailImport'

export const state = {}

export const mutations = {}

export const getters = {}

const data = (response) => response.data?.data

export const actions = {
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  getEmailImportConfig({ commit }) {
    return EmailImportService.getEmailImportConfig().then(data)
  },

  // eslint-disable-next-line no-unused-vars
  createEmailImportRun({ commit }, payload) {
    return EmailImportService.createEmailImportRun(payload).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  getEmailImportRun({ commit }, id) {
    return EmailImportService.getEmailImportRun(id).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  cancelEmailImportRun({ commit }, id) {
    return EmailImportService.cancelEmailImportRun(id).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  createEmailComposeRun({ commit }, payload) {
    return EmailImportService.createEmailComposeRun(payload).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  getEmailComposeRun({ commit }, id) {
    return EmailImportService.getEmailComposeRun(id).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  cancelEmailComposeRun({ commit }, id) {
    return EmailImportService.cancelEmailComposeRun(id).then(data)
  },

  // eslint-disable-next-line no-unused-vars
  detectBrandKit({ commit }, payload) {
    return EmailImportService.detectBrandKit(payload).then(data)
  },
}
